import { Grid } from "@mui/material";
import { ConditionOperator } from "components/Campaign/CampaignConditions/NewFormatCampaignConditions/ConditionOperator/ConditionOperator";
import { ConditionValue } from "components/Campaign/CampaignConditions/NewFormatCampaignConditions/ConditionValue/ConditionValue";
import { CampaignConditionNewFormat, TransactionItem } from "types/campaigns";
import { Params } from "./Params";

interface Props {
  fieldKey: string;
  transactionItemsFilters?: TransactionItem[];
  ruleData: CampaignConditionNewFormat;
}

export const NewFormatCondition = ({
  fieldKey,
  transactionItemsFilters,
  ruleData,
}: Props) => {
  return (
    <>
      <Grid item xs={6}>
        <Params
          ruleData={ruleData}
          fieldKey={fieldKey}
          transactionItemsFilters={transactionItemsFilters}
        />
      </Grid>
      <Grid item xs={6}>
        <ConditionOperator
          type={ruleData.type}
          fieldName={`${fieldKey}.condition`}
        />
      </Grid>
      <Grid item xs={6}>
        <ConditionValue
          type={ruleData.type}
          operator={ruleData.condition?.operator!}
          fieldName={`${fieldKey}.condition.value`}
        />
      </Grid>
    </>
  );
};
